module.exports = __webpack_public_path__ + "static/img/1.bb66c89.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/guangdong/1.jpg
// module id = YSjh
// module chunks = 1